import InsurersService from "@/api/services/insurers";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
  },
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
  },
  actions: {
    async fetchIndex({ commit }) {
      const response = await InsurersService.fetchIndex();
      if (!response?.success) return response;

      const { data } = response;
      commit("setIndex", data.insurers);
    },
  },
};
